/**
 * Output display component.
 * Renders execution results.
 */

import type { FunctionComponent } from 'preact'
import type { OutputConfig } from '../types'

interface OutputDisplayProps {
  outputs: OutputConfig[]
  results: Record<string, unknown>
}

export const OutputDisplay: FunctionComponent<OutputDisplayProps> = ({
  outputs,
  results,
}) => {
  const enabledOutputs = outputs.filter((o) => o.enabled)

  if (enabledOutputs.length === 0) {
    return null
  }

  return (
    <div class="syv-outputs">
      {enabledOutputs.map((output) => (
        <OutputField
          key={output.name}
          output={output}
          value={results[output.name]}
        />
      ))}
    </div>
  )
}

interface OutputFieldProps {
  output: OutputConfig
  value: unknown
}

const OutputField: FunctionComponent<OutputFieldProps> = ({ output, value }) => {
  if (value === undefined || value === null) {
    return null
  }

  return (
    <div class="syv-output">
      <div class="syv-output-label">{output.label}</div>
      <div class="syv-output-value">{formatValue(value)}</div>
    </div>
  )
}

/**
 * Format a value for display.
 */
function formatValue(value: unknown): string {
  if (typeof value === 'string') {
    return value
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value)
  }
  if (Array.isArray(value)) {
    return value.map(formatValue).join('\n')
  }
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value, null, 2)
  }
  return String(value)
}
